export default "__VITE_ASSET__B2q6i6ks__"